'use strict';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import {Observable} from 'rxjs/Observable';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {updateLoadingMode} from '../loading-icon/utils';
import filterTemplate from './filters/selector-filter.html';
import {logger} from './logger';


module.exports = [
  '$filter',
  'BaseFilterMixin',
  SelectorFilterMixin];

function SelectorFilterMixin(
  $filter,
  BaseFilterMixin,
) {
  return function filter(vm, $scope, toStringMethod, currentFilter) {
    const baseFilter = new BaseFilterMixin($scope, {
      controllerAs: 'selector',
      filterTemplate: filterTemplate,
      initialFilter: currentFilter,
      defaultSortProperty: 'name',
      filterOptions: {}
    });

    return {
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter)
    };

    function initFiltering(list) {
      if (!list || !isFunction(list.$toObservable)) {
        vm.filteredList = list;
        return;
      }
      baseFilter.registerFilter('filteredList');

      const list$ = list
        .$toObservable()
        .map($filter.toArray);

      const filteredList$ = Observable.combineLatest(
        list$,
        baseFilter.sortOptionsObservable,
        baseFilter.filterObservable,
        (list, sortOptions, autoFilter) => {
          const sorted = applySortOptions(list, sortOptions);
          return filterWithToString(sorted, autoFilter)
        })
        .catch(epicErrorHandler(logger, 'filteredList$'));

      baseFilter.activeSubscriptions.push(updateLoadingMode(list$, $scope, vm));

      baseFilter.activeSubscriptions.push(filteredList$.subscribe(function (results) {
        $scope.$safeApply($filter.$replaceArrayContents.bind($filter, vm.filteredList, results));
      }));

      function filterWithToString(list, query) {
        if (!query || typeof query !== 'string') return list;

        query = query.toLowerCase();

        const result = [];
        let item;

        for (let i = 0, length = list.length; i < length; i++) {
          item = list[i];

          if (item && isObject(item)) {
            if (item && item[toStringMethod]().toLowerCase().indexOf(query) > -1) {
              result.push(item);
            }
          }
        }

        return result;
      }

      function applySortOptions(list, sortOptions) {
        return list.sort($filter.$sortByPropertyAccessor(getAsString, sortOptions.currentMethod, true));
      }

      function getAsString(item) {
        return item[toStringMethod]();
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-components/selectors/SelectorFilterMixin.js